//
//
//
//
//
//
//

export default {
  name: "Download",
  data(){
    return{
      path:this.$route.query.path,
      suffix:this.$route.query.suffix
    }
  },
  methods:{
    is_weixin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("微信浏览器");
        return true;
      } else {
        console.log("不是微信浏览器");
        return false;
      }
    },


    dataURLtoBlob(dataurl, encode) {
        var arr = dataurl, 
          bstr = atob(arr), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: encode });
    },

    download(){
      let is_weixin = this.is_weixin();
      this.$vux.loading.show({
        text: 'Loading'
      })
      if (is_weixin) {
        alert('点击右上角选择在浏览器打开');
        this.$vux.loading.hide()
        //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        return
      } else {
        //不是微信浏览器
        //执行下载
        this.$http.get('api/v1/photos?path=' + this.path).then(res => {
          const aLink = document.createElement('a');
          let encode = '';
          let bm = '';
          const type = this.suffix.split('.');
          switch (type[type.length - 1]) {
            case 'doc':
            case 'docx':
              encode = 'application/vnd.ms-word;charset=utf-8';
              bm = 'base64';
              break;
            case 'pdf':
              encode = 'application/pdf;charset=utf-8';
              bm = 'base64';
              break;
            case 'xlsx':
            case 'xls':
              encode = 'application/vnd.ms-excel;charset=utf-8';
              bm = 'base64';
              break;
            case 'ppt':
            case 'pptx':
              encode = 'pplication/vnd.ms-powerpoint;charset=utf-8';
              bm = 'base64';
              break;
            default:
              encode = 'text/plain;charset=utf-8';
              bm = 'base64';
              break;
          }
          if ( !encode ){
            alert('暂不支持此格式下载');
            return
          }
          this.$vux.loading.hide()
          // var decodedData = atob(res.data["value"]);
         // var blob = new Blob([decodedData], {type: encode});
            var blob = this.dataURLtoBlob(res.data["value"],encode)
          var evt = document.createEvent("MouseEvents");
          evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错, 感谢 Barret Lee 的反馈
          aLink.download = this.suffix;
          aLink.href = URL.createObjectURL(blob);
          aLink.dispatchEvent(evt);
         
        });
      }
    }
  },
  mounted(){
    this.$nextTick(()=>{
      setTimeout(()=>{
        let is_weixin = this.is_weixin();
        if (is_weixin) {
          alert('点击右上角选择在浏览器打开');
          //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        }
      })
    },2000)
  },
  created(){
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;  //安卓终端
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);                //苹果终端
    if (isAndroid) { //判断为安卓手机
      // this.showBox = false;
    }else if (isIOS) {     //判断为苹果手机
      // alert('这里苹果手机');
      // this.showBox = true; //判断显示的是哪一个页面，我这边设置的就是如果为true就显示iOS的页面，如果为false就显示安卓的页面
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Download.vue